import type { ApprovalChain } from '../approval-chain.model';

export const DEED_TRANSFER_CHAIN: ApprovalChain = {
  id: 'deed-transfer',
  label: 'Deed of Transfer',
  applicationTypes: ['DEED_TRANSFER'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
